/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService, CommonActions, CommonFlowState, ListActionPipelines } from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { getRouteInitData, UserContext } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { DialogService } from '@gh/core-ui';
import { GridDefinitionFactory, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { LocationBusinessService } from '../../resources/location-business.service';
import { Location } from '../../resources/location.model';
import { locationDetailsDialog } from '../location-details-dialog/location-details-dialog.route';

@Component({
  selector: 'gh-location-list-tab',
  template: require('./location-list-tab.component.html'),
  styles: [require('./location-list-tab.component.scss')],
})
export class LocationListTabComponent implements OnInit {
  dataSource: SlicedDataSource<Location>;
  gridDefinition: LayoutBasedGridDefinition;

  constructor(private route: ActivatedRoute,
              private userContext: UserContext,
              private dialogService: DialogService,
              private navigationService: BuilderNavigationService,
              private locationBusiness: LocationBusinessService,
              private pipelines: ListActionPipelines,
              private commonActions: CommonActions,
              private gridDefinitionFactory: GridDefinitionFactory) {
    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased({}, {
      getRowNodeId: (location: Location) => location.id,
    });
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    const { gridLayout } = getRouteInitData(this.route);

    this.gridDefinition.bind(gridLayout);

    this.loadData();
  }

  onEdit(editedLocation: Location): void {
    if (this.userContext.hasPermission(BuilderPermission.Setup.Contacts.CityStateZipCodes.EDIT)) {
      this.dialogService.openWithInput(locationDetailsDialog, {
        modelId: editedLocation.id,
      }).afterClosed().subscribe((location) => {
        if (location) {
          this.reload();
        }
      });
    }
  }

  reload(): void {
    this.loadData();
  }

  loadData(): void {
    this.dataSource = this.locationBusiness.findAllAsDataSource();
  }

  onDelete(editedLocation: Location): void {
    const flow = this.pipelines.toggleItem({
      question: 'msg_location_delete',
      execute: this.commonActions.execute((state: CommonFlowState<Location>) =>
        this.locationBusiness.remove(state.value)),
      finish: () => this.reload(),
    });

    flow.run({
      value: editedLocation,
    });
  }

  goToAel(entityId?: ID, entityType?: string, label?: string): void {
    this.navigationService.goToAel({
      entityId: entityId ? entityId : undefined,
      entityType: entityType ? entityType : 'LOCATION',
      label: label ? label : 'lbl_locations',
    });
  }

}
